// src/pages/ForgotPassword.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import api from '../services/api';
import AuthShell, { IconArrow, IconBack, IconCheck } from '../components/auth/AuthShell';


export default function ForgotPassword() {
    const [email,   setEmail]   = useState('');
    const [loading, setLoading] = useState(false);
    const [sent,    setSent]    = useState(false);
    const [error,   setError]   = useState('');

    const handleSubmit = async e => {
        e.preventDefault();
        setLoading(true);
        setError('');
        try {
            await api.post('/auth/forgot-password', { email: email.trim().toLowerCase() });
            setSent(true);
        } catch (err) {
            setError(err.response?.data?.error || 'Error al enviar. Intenta de nuevo.');
        } finally {
            setLoading(false);
        }
    };

    if (sent) {
        return (
            <AuthShell>
                <div style={{ textAlign: 'center' }}>
                    <div className="auth-success-icon">
                        <IconCheck />
                    </div>
                    <h1 className="auth-title">Correo enviado</h1>
                    <p className="auth-subtitle">
                        Revisa tu bandeja de entrada. Te enviamos las instrucciones para restablecer tu contraseña.
                    </p>
                    <Link to="/login" className="auth-link" style={{ fontSize: 14 }}>
                        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                            <IconBack /> Volver al inicio de sesión
                        </span>
                    </Link>
                </div>
            </AuthShell>
        );
    }

    return (
        <AuthShell>
            <h1 className="auth-title">Recuperar contraseña</h1>
            <p className="auth-subtitle">
                Ingresa tu correo y te enviaremos un enlace para restablecer tu contraseña.
            </p>

            {error && (
                <div className="auth-alert">{error}</div>
            )}

            <form onSubmit={handleSubmit}>
                <div className="auth-field">
                    <label className="auth-label" htmlFor="fp-email">Correo electrónico</label>
                    <input
                        id="fp-email"
                        type="email"
                        className="auth-input"
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                        placeholder="tu@correo.com"
                        required autoFocus autoComplete="email"
                    />
                </div>

                <button type="submit" className="auth-submit" disabled={loading}>
                    {loading ? <Spinner size="sm" animation="border" /> : <>Enviar instrucciones <IconArrow /></>}
                </button>
            </form>

            <div className="auth-footer-link">
                <Link to="/login">
                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
                        <IconBack /> Volver al inicio de sesión
                    </span>
                </Link>
            </div>
        </AuthShell>
    );
}
